import { ChevronDown, ChevronUp } from "@tamagui/lucide-icons";
import { ReactNode } from "react";
import {
  ButtonProps,
  ListItem,
  Popover,
  PopoverTriggerProps,
  styled,
  usePopoverContext,
  withStaticProperties,
} from "tamagui";

const Wrapper = styled(Popover, {
  allowFlip: true,
  stayInFrame: true,
  offset: 8,
  resize: true,
  placement: "bottom-start",
});

type TriggerFunctionProps = {
  open: boolean;
  chevronIcon: ButtonProps["iconAfter"];
};

interface TriggerProps extends Omit<PopoverTriggerProps, "children"> {
  children: ReactNode | ((props: TriggerFunctionProps) => ReactNode);
}

const Trigger = ({ children: childrenOrFunction, ...rest }: TriggerProps) => {
  const { open } = usePopoverContext();

  const chevronIcon = open ? (
    <ChevronUp size="$1.5" />
  ) : (
    <ChevronDown size="$1.5" />
  );

  const children =
    typeof childrenOrFunction === "function"
      ? childrenOrFunction({
          open,
          chevronIcon,
        })
      : childrenOrFunction;

  return (
    <Popover.Trigger asChild {...rest}>
      {children}
    </Popover.Trigger>
  );
};

const Menu = styled(Popover.Content, {
  backgroundColor: "$gray6",
  paddingHorizontal: 0,
  paddingVertical: "$2.5",
  borderRadius: "$6",
  overflow: "hidden",
  enterStyle: { y: -10, opacity: 0 },
  exitStyle: { y: -10, opacity: 0 },
  animation: ["fast", { opacity: { overshootClamping: true } }],
});

const MenuItem = styled(ListItem, {
  backgroundColor: "$gray6",
  hoverTheme: true,
  hoverStyle: { backgroundColor: "$gray7" },
  pressTheme: true,
  pressStyle: { backgroundColor: "$gray8" },
});

export const ActionMenu = withStaticProperties(Wrapper, {
  Trigger,
  Menu,
  MenuItem,
});
